import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const seoEnable = isFeature('seo-enable');
